import { Component, Input, OnInit } from '@angular/core';

import { IAuthorityHistoryChange } from '../../models/authority-history-change.interace';
import { AuthorityHistoryChangeModel } from '../../models/authority-history-change.model';
import { IAuthorityHistoryCommonChange } from '../../models/authority-history-common.interface';
import { IAuthorityModification } from '../../models/authority-modification.interface';
import { AuthorityModificationModal } from '../../models/authority-modification.model';
import { DataShareService } from '../../services/data-share.service';

@Component({
  selector: 'authority-modification',
  templateUrl: 'authority-modification.component.html',
  styleUrls: ['./authority-modification.component.scss']
})
export class AuthorityModificationComponent implements OnInit {
  @Input() authorityHistoryChanges: IAuthorityHistoryChange[];
  @Input() authorityHistoryCommonChange: IAuthorityHistoryCommonChange;
  @Input() isInitialAuthority: Boolean;
  @Input() isAuthoritySharedModel: Boolean = false;
  @Input() ec1Number: String;
  public trackAuthorityChangeDetails: AuthorityModificationModal;
  constructor(private dataShareService: DataShareService) {}

  ngOnInit() {
    let authorityModification = {} as IAuthorityModification;
    authorityModification.changeType = this.authorityHistoryCommonChange.changeType;
    authorityModification.dispatcher = this.authorityHistoryCommonChange.dispatcher;
    authorityModification.requestedById = this.authorityHistoryCommonChange.requestedById;
    authorityModification.requestedByName = this.authorityHistoryCommonChange.requestedByName;
    authorityModification.changeTimeStamp = this.authorityHistoryCommonChange.changeTimeStamp;
    authorityModification.rejectedByName = this.authorityHistoryCommonChange.rejectedByName;
    authorityModification.rejectedById = this.authorityHistoryCommonChange.rejectedById;
    authorityModification.rejectionReason = this.authorityHistoryCommonChange.rejectionReason;
    this.setAuthorityModificationView(authorityModification);
    this.trackAuthorityChangeDetails = new AuthorityModificationModal(authorityModification, this.dataShareService);
  }

  setAuthorityModificationView(authorityModification: IAuthorityModification) {
    if (this.authorityHistoryChanges.length > 1) {
      authorityModification.multipleModifications = [];
      this.getMultipleChanges(authorityModification);
    } else {
      authorityModification.changeText = this.authorityHistoryChanges[0].changeText;
    }
  }

  getMultipleChanges(authorityModification: IAuthorityModification) {
    for (let i = 0; i < this.authorityHistoryChanges.length; i++) {
      let authorityMultipleModification = new AuthorityHistoryChangeModel(this.authorityHistoryChanges[i]);
      let changeText = authorityMultipleModification.changeText;
      authorityModification.multipleModifications.push(changeText);
    }
  }
}
